import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useFilterListAtom } from '../ItemList/FilterList/Provider/filterList/useFilterListAtom';
import { queryKey } from '../../../constant';
import { useInstanceId } from '../../../hooks';

/**
 * 필터 변경 → 다음 getScreens 완료 시점에 Proxy 쿼리 reset.
 */
export const useResetProxyQueriesOnFilterChange = ({
  isFetching,
  enabled,
}: {
  isFetching: boolean;
  enabled: boolean;
}) => {
  const queryClient = useQueryClient();
  const instanceId = useInstanceId();
  const { filterListAtomValue } = useFilterListAtom();

  const shouldResetRef = useRef(false);

  const prevFilterRef = useRef(filterListAtomValue);
  const prevFetchingRef = useRef(isFetching);

  // Phase 1: 필터 변경 감지 → reset 예약
  useEffect(() => {
    const changed = prevFilterRef.current !== filterListAtomValue;
    prevFilterRef.current = filterListAtomValue;
    if (enabled && changed) shouldResetRef.current = true;
  }, [filterListAtomValue, enabled]);

  // Phase 2: fetch 완료 시점에 예약된 reset 실행
  useEffect(() => {
    if (!enabled) return;
    const didFinishFetch = prevFetchingRef.current && !isFetching;
    prevFetchingRef.current = isFetching;
    if (didFinishFetch && shouldResetRef.current) {
      queryClient.resetQueries({ queryKey: queryKey.proxy(instanceId) });
      shouldResetRef.current = false;
    }
  }, [isFetching, queryClient, enabled, instanceId]);
};
